import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires',
  time: '3 minutos'
}, {
  name: 'Juan',
  city: 'Córdoba',
  time: '7 minutos'
}, {
  name: 'Lucía',
  city: 'Rosario',
  time: '12 minutos'
}, {
  name: 'Pedro',
  city: 'Mendoza',
  time: '5 minutos'
}, {
  name: 'Ana',
  city: 'La Plata',
  time: '9 minutos'
}, {
  name: 'Diego',
  city: 'Tucumán',
  time: '2 minutos'
}, {
  name: 'Florencia',
  city: 'Mar del Plata',
  time: '15 minutos'
}, {
  name: 'Martín',
  city: 'Salta',
  time: '6 minutos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const cycleInterval = setInterval(() => {
      if (isDismissed) return;
      setIsVisible(false);
      setTimeout(() => {
        if (isDismissed) return;
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 2000);
    }, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
    };
  }, [isDismissed]);
  useEffect(() => {
    if (isVisible && !isDismissed) {
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentPurchase = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-288">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-289">
          <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3 relative overflow-hidden" data-id="element-290">
            <button onClick={() => setIsDismissed(true)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 p-1" data-id="element-291">
              <XIcon size={14} data-id="element-292" />
            </button>

            <div className="flex-shrink-0 relative" data-id="element-293">
              <img src="https://cdn.magicpatterns.com/uploads/4SGBKtYBU5JVJXtid656DM/mockups_lenguA_.png" alt="Product" className="w-12 h-12 object-cover rounded-md border border-gray-100" data-id="element-294" />
              <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-0.5 border-2 border-white" data-id="element-295">
                <CheckCircle2Icon size={10} className="text-white" data-id="element-296" />
              </div>
            </div>

            <div className="flex-1 pr-4" data-id="element-297">
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-298">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-299">
                compró el Kit de Lengua hace{' '}
                <span className="font-medium text-green-600" data-id="element-300">
                  {currentPurchase.time}
                </span>
              </p>
              <div className="flex items-center mt-1" data-id="element-301">
                <div className="flex" data-id="element-302">
                  <span className="text-[#fbbf24] text-[10px]" data-id="element-303">★</span>
                  <span className="text-[#fbbf24] text-[10px]" data-id="element-304">★</span>
                  <span className="text-[#fbbf24] text-[10px]" data-id="element-305">★</span>
                  <span className="text-[#fbbf24] text-[10px]" data-id="element-306">★</span>
                  <span className="text-[#fbbf24] text-[10px]" data-id="element-307">★</span>
                </div>
                <span className="text-[10px] text-gray-400 ml-1" data-id="element-308">
                  Verificado
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}